import { useState } from 'react';
import SendIcon from '@mui/icons-material/Send';
import { Accordion } from '../../../../../../components/general/accordion';
import { Table } from '../../../../../../components/general/table';
import { Account } from '../../../../../../../shared/types/modules/account';
import { EmailSendingRecord } from '../../../../../../../services/emailSending.service';
import { DetailEmailSending } from './DetailEmailSending';
import { useEmailSendingHistory } from './hook';

type Props = {
    account?: Account;
};

export const HistoryEmailSending = ({ account }: Props) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<EmailSendingRecord>();
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useEmailSendingHistory(account?.id, open);

    return (
        <Accordion
            title="HISTÓRICO ENVIO EMAIL"
            icon={<SendIcon sx={{ color: 'primary.main' }} />}
            mt={0}
            expanded={open}
            defaultExpanded={false}
            onChange={(_event, isOpen) => setOpen(isOpen)}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{ page, pageSize }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[10, 20, 50]}
                onRowClick={({ row }) => setSelected(row)}
                disableRowSelectionOnClick
            />

            <DetailEmailSending
                emailSending={selected}
                onClose={() => setSelected(undefined)}
            />
        </Accordion>
    );
};